import api from "app/api";
import { PaginationResponse } from "common/modules/api/createApiService";
import { DbFile } from "common/types";
import { BookingItem } from "features/bookings/bookingApi";

export const BOOKING_DOCUMENT_TYPES = {
  SCRIPT: "script",
} as const;

export type BookingDocumentType =
  (typeof BOOKING_DOCUMENT_TYPES)[keyof typeof BOOKING_DOCUMENT_TYPES];

export interface BookingDocumentItem {
  id: number;
  booking_id: number;
  file_id?: number;
  type: BookingDocumentType;
  name?: string;
  description?: string;
  created_at: string;
  updated_at: string;
  booking?: BookingItem;
  file?: DbFile;
}

export function getBookingDocumentService(
  scope?: any,
  urlParams?: Record<string, any>,
) {
  return api.getService<BookingDocumentItem>("booking-documents", {
    scope,
    urlParams,
  });
}

export function getScriptListData(
  startDate: string | undefined,
  endDate: string | undefined,
  boatIds: number[] | null,
  programIds: number[] | null,
) {
  return api.get<PaginationResponse<BookingDocumentItem>>(
    "/booking-documents",
    {
      params: {
        type: BOOKING_DOCUMENT_TYPES.SCRIPT,
        from: startDate,
        to: endDate,
        boatIds,
        programIds,
      },
    },
  );
}
